export enum ApplepayStatus {
    Ready = "ready",
    CheckingForm = "checkingForm",
    AddingProductToCart = "addingProductToCart",
    TermValidating = "termValidating",
    Buying = "buying",
}
